<template>
    <div>
  
      <div class="table_card">
        <div class="table_card__head">
          <v-layout row wrap fill-height>
            <v-flex xs12 lg5>
              <p class="table_card__head--title">Nueva plantilla para mensajes</p>
              <v-breadcrumbs class="breadcums">
                <v-icon slot="divider">chevron_right</v-icon>
                <v-breadcrumbs-item
                  class="breadcums__option"
                  @click="$router.push({name: 'whatsapp_templates'})"
                >
                  Plantillas
                </v-breadcrumbs-item>
                <v-breadcrumbs-item
                  class="breadcums__option"
                  disabled
                >
                  Nueva plantilla
                </v-breadcrumbs-item>
              </v-breadcrumbs>
            </v-flex>
            <v-flex xs12 lg7 class="filter_options">
              <button
                type="button"
                class="faccess_button px-5"
                @click="createTemplate()"
                :disabled="!valid || template_info.attributes.name == '' || template_info.attributes.message == '' "
              >
                Crear
              </button>
            </v-flex>
          </v-layout>
        </div>
        <div class="table_card__body">
          <v-layout row wrap>
            <v-flex xs12 row>
              <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
                <v-layout
                  row
                  wrap
                  style="background-color: #fff; padding: 0px;">
                  <v-flex
                    xs6
                    style="padding: 20px">
                    <v-text-field
                      v-model="template_info.attributes.name"
                      label="Nombre"
                      required
                      placeholder="Máximo 200 caracteres"
                      :rules="[rules.required, rules.name]"
                      counter="200"></v-text-field>
                  </v-flex>
                  <v-flex
                    xs6
                    style="padding: 8px">
                    <v-textarea
                      v-model="template_info.attributes.message"
                      label="Mensaje"
                      required
                      placeholder="Máximo 900 caracteres"
                      :rules="[rules.required, rules.message]"
                      @input="convertNewlines"
                      counter="900"></v-textarea>
                  </v-flex>
                </v-layout>
  
                <v-layout row wrap>
                    <v-flex xs4>
                    <span class="table_card__info--label">Cargar imagen (Formato jpg o png)</span>
                    <div class="trainers__form--photo_container" style="width:max-content">
                        <label
                        for="trainerPhoto"
                        class="faccess_button buttom_shadow px-5">Examinar</label>
                        <input
                        id="trainerPhoto"
                        type="file"
                        accept="image/x-png,image/jpeg"
                        @change="onFileChange"
                        name="photo">

                    </div>

                    </v-flex>


                  <v-flex xs4>
                    <div
                    class="data_card__import_img"
                    :style="{backgroundImage: 'url('+ url_image +')'}">
                  </div>
                  </v-flex>

                </v-layout>
  
              </v-form>
            </v-flex>
          </v-layout>
        </div>
        <div class="table_card__footer">
          <button
            type="button"
            class="faccess_button px-5"
            @click="createTemplate()"
            :disabled="!valid || template_info.attributes.name == '' || template_info.attributes.message == '' "
          >
            Crear
          </button>
        </div>
      </div>
  
  
    </div>
  
  </template>
  
  <script>
  export default {
    data(){
      return{
        selected: 'Todos los usuarios',
        message_selector: ['Todos los usuarios', 'Varios usuarios'],
        url_image: '',
        template_info: {
          attributes: {
            name: '',
            message: '',
            formatmessage:'',
            image: ''
          }
        },
        rules: {
          required: value => !!value || 'Required.',
          name: value => value.length <= 200 || 'Maximo 45 caracteres',
          message: value => value.length <= 900 || 'Maximo 900 caracteres',
        },
        valid: false
      }
    },

    methods: {

        convertNewlines() {
            this.template_info.attributes.formatmessage = this.template_info.attributes.message.replace(/\n/g, '\\n');
        },

        onFileChange (e) {

            var fileInput = document.getElementById('trainerPhoto');
            var filePath = fileInput.value;
            var extension = filePath.replace(/^.*\./, '').toLowerCase();

            var fileSize = parseInt(fileInput.files[0].size /1024)
            var allowedExtensionsImg = ['jpg','jpeg','png']


            if( !allowedExtensionsImg.includes(extension) ){
                this.updateAlertMessage('Solo se admite el formato jpg o jpeg')
                this.updateIsInAlert(true);
                return
            }else if(fileSize > 5000){
                this.updateAlertMessage('El tamaño de la foto no puede ser mayor a 5MB')
                this.updateIsInAlert(true);
                return
            }else{

                var files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    return
                }
                this.url_image = URL.createObjectURL(files[0])

                this.createImage(files[0], ""+e.target.name)

            }



        },
        createImage (file, name_field) {
            var reader = new FileReader()
            var vm = this
            reader.readAsDataURL(file);
            reader.onload = function () {
            vm.template_info.attributes.image = reader.result
        }
},
      createTemplate(){

        var data = { template_info: this.template_info}
        try {
          this.$http.post('push_messages_templates/create_template',{
            data: this.encrypt(data).toString()
          },{
            headers: {
              "X-Device-ID" : this.getDeviceId(),
               "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }).then(function(response){
            this.updateAlertMessage(response.body.ans);
            this.updateIsInAlert(true);
            this.$router.push({name: 'whatsapp_templates'})
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            this.updateAlertMessage(response.body.ans);
            this.updateIsInAlert(true);
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          })
        } catch (e) {
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          alert(e.message)
        }
      }
    },
    watch: {
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/views/whatsapp_templates/New_template.vue